import { useEffect } from "react";
import { createUseStyles } from "react-jss";
import TextInput from "../../refresh/inputs/TextInput";
import { useMediaSelector } from "../../refresh/selectors/MediaSelector";
import styles from "../types/sharedStyles";
import Label from "../../refresh/Label";

const useStyles = createUseStyles({
  ...styles,
  button: {
    display: "inline-block",
    "background-color": "#252525",
    color: "white",
    border: "none",
    cursor: "pointer",
    "border-radius": 3,
    margin: [5, 3, 0, 0],
    padding: [3, 8],
  },
});

const labels = {
  mp4: "url",
  youtube: "youtube url",
  vimeo: "vimeo url",
};

const VideoElement = ({ onChange, value }) => {
  const [media, getMedia, setMedia] = useMediaSelector(value.video ?? {});
  const classes = useStyles();

  useEffect(() => {
    if (media.id) {
      onChange({
        video_type: "cms",
        video: {
          id: media.id,
          name: media.title,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media.id]);

  useEffect(() => {
    if (value.video_type !== "cms") {
      setMedia({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.video_type]);

  return (
    <>
      <Label name="Video type" required>
        <div>
          <button
            style={
              value.video_type === "cms" ? { backgroundColor: "#f90" } : {}
            }
            className={classes.button}
            onClick={() => onChange({ ...value, video_type: "cms" })}
          >
            CMS
          </button>
          <button
            style={
              value.video_type === "vimeo" ? { backgroundColor: "#f90" } : {}
            }
            className={classes.button}
            onClick={() => onChange({ ...value, video_type: "vimeo" })}
          >
            Vimeo
          </button>
          <button
            style={
              value.video_type === "youtube" ? { backgroundColor: "#f90" } : {}
            }
            className={classes.button}
            onClick={() => onChange({ ...value, video_type: "youtube" })}
          >
            Youtube
          </button>
          <button
            style={
              value.video_type === "mp4" ? { backgroundColor: "#f90" } : {}
            }
            className={classes.button}
            onClick={() => onChange({ ...value, video_type: "mp4" })}
          >
            External Link
          </button>
        </div>
      </Label>
      {value.video_type === "cms" ? (
        <Label name="Video clip" required>
          <div className={classes.genericSelector}>
            <p>{value.video?.name || "Select a video clip"}</p>
            <button onClick={() => getMedia([2])}>Select from CMS</button>
          </div>
        </Label>
      ) : (
        <TextInput
          label={labels[value.video_type]}
          required
          value={value.url}
          onChange={url => onChange({ video_type: value.video_type, url })}
        />
      )}
    </>
  );
};

export default VideoElement;
